import { API_STATES } from '@/helpers'

const state = {
  companyRegistrationState : API_STATES.NOT_REQUESTED,
  companyRegistrationError : null
}

export default state
